import React, { useMemo } from 'react'
import { ItemProps } from './block'
import style from './block.module.scss'

export interface NavItemProps extends ItemProps {
    parentSlug?: string | null
    sameLevelItems?: ItemProps[]
}

const activeItem = (url: string, strict: boolean = false) => {
    if (url.charAt(url.length - 1) !== '/') {
        url += '/'
    }

    if (url.startsWith('https')) {
        return strict ? window.location.href === url : window.location.href.startsWith(url)
    } else {
        return strict ? window.location.pathname === url : window.location.pathname.startsWith(url)
    }
}

export const NavItem = ({ url, label, parentSlug, sameLevelItems = [] }: NavItemProps) => {
    const isActive = useMemo(() => {
        return (
            (activeItem(url) || parentSlug === url) &&
            sameLevelItems
                .filter((item) => item.url !== url) // Not check against the current item
                .every((item) => !activeItem(item.url, true)) // Check if there is an item on same menu level that match strictly
        )
    }, [url, parentSlug, sameLevelItems])

    return (
        <li>
            <a href={url} className={isActive ? style.active : undefined}>
                {label}
            </a>
        </li>
    )
}
